import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Home from '../Home';
import Navigation from '../Navigation';
import SignInPage from '../SignIn';
import SignUp from '../SignUp';
import MeusDados from '../../pages/MeusDados';
import MinhasSolicitacoes from '../../pages/Minhas_solicitacoes';
import Solicitar from '../../pages/Solicitar';
import EscolherProfissional from '../../pages/Solicitar/selecionarProfissional';
import Termo from '../../pages/Termo';

import * as ROUTES from '../../constants/routes';

import { withAuthentication } from '../Session';


const App = () => (
    <Router>
            <Route path={ROUTES.LANDING} component={Home} />
            <Route path={ROUTES.TERMO} component={Termo} />
            <Route path={ROUTES.SIGN_IN} component={SignInPage} />
            <Route path={ROUTES.SIGN_UP} component={SignUp} />
            <Route path={ROUTES.MEUS_DADOS} component={MeusDados} />
            <Route path={ROUTES.MINHAS_SOLICITACOES} component={MinhasSolicitacoes} />
            <Route path={ROUTES.SOLICITAR} component={Solicitar} />
            <Route path={ROUTES.ESCOLHER_PROFISSIONAL} component={EscolherProfissional} />
    </Router>

);

export default withAuthentication(App);